import type { RefObject } from "react";

/**
 * Utilities for accessing MUI DataGrid's private internal API.
 * The private API is exposed via an internal symbol and is not part of the
 * public contract, so it's isolated here to make call-sites clean and to
 * limit the blast radius if MUI changes the symbol name.
 */

/**
 * Calls removeChildrenRows on MUI's private API for the given row ID.
 * Used when collapsing a group or when re-fetching children after a
 * pagination change — both cases need the stale child rows cleared first.
 */
export function removeChildrenRows(
  apiRef: RefObject<any>,
  rowId: string | number
): void {
  if (!apiRef.current) return;
  const privateSymbol = Object.getOwnPropertySymbols(apiRef.current).find(
    (s) => s.toString() === "Symbol(mui.api_private)"
  );
  if (privateSymbol) {
    const privateApi = (apiRef.current as any)[privateSymbol];
    privateApi.removeChildrenRows(rowId);
  }
}
